import { AgentState } from '../Enums/AgentState';
import { BusinessArea } from '../Enums/BusinessArea';
import { ServiceClient } from '../Services/ServiceClient';

export const isAgentActive = agent => {
  if (!agent || !agent.state) return false;

  return agent.state === AgentState.Active || agent.state === AgentState.NotActiveYet;
};

export const doesTeamAlreadyExistAsync = codePrefix => {
  return new Promise(resolve => {
    ServiceClient.doesCodePrefixExist(codePrefix, data => {
      resolve(data);
    });
  });
};

export const getAdUserDetailsAsync = userId => {
  return new Promise(resolve => {
    ServiceClient.getUserDetailsFromADbyUserID(userId, data => {
      resolve(data);
    });
  });
};

export function getBusinessAreaByChannel(channel) {
  switch (channel?.generalLedgerCostCenterCode?.charAt(0)) {
    case 'K':
      return BusinessArea.Private;
    case 'C':
      return BusinessArea.Commercial;
    case 'B':
      return BusinessArea.Industrial;
    default:
      return null;
  }
}

export const mapLegalUnitCodeToName = legalUnitCode =>
  ({
    SE: 'Sweden',
    DK: 'Denmark',
    NO: 'Norway',
    FI: 'Finland',
  }[legalUnitCode] || null);

export const getActiveAgentWithLowestCode = team => {
  let firstAgent = null;

  (team?.agents ?? []).forEach(agent => {
    if (!isAgentActive(agent)) return;

    if (!firstAgent) {
      firstAgent = agent;
      return;
    }

    if (getAgentCodeNumber(firstAgent.code) > getAgentCodeNumber(agent.code)) {
      firstAgent = agent;
    }
  });

  return firstAgent;
};

export const isCodePrefixFormatCorrect = codePrefix => {
  return codePrefix && codePrefix.match(/^[a-zA-Z0-9]{3,8}$/);
};

export const getActiveAgent = (team, agentCode) => {
  return (
    team?.agents?.find(agent => agent.code?.toLowerCase() === agentCode?.toLowerCase() && isAgentActive(agent)) ?? null
  );
};

const getAgentCodeNumber = agentCode => {
  return parseInt(agentCode?.split('-')[1]);
};
